import { Key } from "react";
import { ISelectOption, ITreeSelectData } from "@/types/FmsTypes";

export enum SearchTypeEnum {
    'Input' = 'input',
    'Select' = 'select',
    'TreeSelect' = 'treeSelect',
    'Datepicker' = 'datepicker',
    'RangePicker' = 'rangePicker',
    'Button' = 'button',
    'CheckBox' = 'checkBox',
    'AsyncSelect' = "asyncSelect",
    'ScmRangePicker' = "ScmRangePicker",
    'FullRangePicker' = "FullRangePicker",
}

export interface ISearchValue {
    [propName: string]: string | number | [string, string] | object | string[]
}
export interface IFmsSearchValue {
    [propName: string]: string | undefined | [string, string] | { startTime: string, endTime: string }
}

export type TreeDsType = {
    key: Key,
    title?: string,
    children?: TreeDsType[],
    disabled?: boolean,
    selectable?: boolean
}
export interface ISearchField {
    fieldName: string;
    type: SearchTypeEnum;
    placeholder?: string | string[];
    showTime?: Object | boolean;
    format?: string;
    xxl?: number;
    lg?: number;
    span?: number;
    disabled?: boolean;
    size?: string;
    options?: { label: string, value: any }[],
    treeDs?: TreeDsType[] | ITreeSelectData[],
    selectfetchList?: (search: string) => Promise<ISelectOption[]>,
    rangePickerFieldName?: string[] | ["startTime", "endTime"],  //供应链专用字段
    [key: string]: any
}

type Isize = 'large' | 'middle' | 'small';

export interface ISearchProp {
    title?: string | JSX.Element;
    triggerSearch?: boolean,
    searchFields?: ISearchField[],
    searchMoreFields?: ISearchField[],
    searchValues?: ISearchValue | any,
    onChange?: (arg: ISearchValue | any, arg2?: any) => void
    onFmsChange?: (arg: IFmsSearchValue) => void
    handleReset?: () => void;
    handleSearch?: (arg?: ISearchValue, arg2?: any) => void;
    onClick?: () => void;
    size?: Isize,
    justify?: "start" | "end",
    style?: React.CSSProperties;
}
